import addType from './add-type'
import banks from './banks'
import browserMore from './browser-more'
import institution from './institution'
import menu from './menu'
import notice from './notice'
import status from './status'
import subsidy from './subsidy'
import taxrefund from './taxrefund'
import icons from './icons'

export default {
  'add-type': addType,
  banks,
  'browser-more': browserMore,
  institution,
  menu,
  notice,
  status,
  subsidy,
  taxrefund,
  icons,
  'cert-active.svg': 'cert-active.svg',
  'cert.svg': 'cert.svg',
  'confetti.png': 'confetti.png',
  'envelope.png': 'envelope.png',
  'excl-ques.png': 'excl-ques.png',
  'keep-kr-s.png': 'keep-kr-s.png',
  'logo-kakao.svg': 'logo-kakao.svg',
  'logo-keep.svg': 'logo-keep.svg',
  'logo_p.ico': 'logo_p.ico',
  'paper-plane.png': 'paper-plane.png',
  'security.gif': 'security.gif',
  'warning.png': 'warning.png',
  'question.png': 'question.png',
  'thumbs-up.png': 'thumbs-up.png',
  'logo-more-taxes.jpg': 'logo-more-taxes.jpg',
  'logo-overtax.png': 'logo-overtax.png',
  'overtax-kr-s.png': 'overtax-kr-s.png',
}
